export const getContactSettingOptions = (
  t,
  objectSettingsAccess,
  hasAiPreview
) =>
  [
    {
      value: 'contactSettings',
      label: t('Object Settings'),
    },
    objectSettingsAccess.customize_fields.edit && {
      value: 'customizeFields',
      label: t('Customize Fields'),
    },
    hasAiPreview && {
      value: 'settingAiAgent',
      label: t('Settings AI Agent'),
    },
  ].filter(Boolean);
